<template>
  <ValidationProvider v-slot="{ valid, errors }" :name="$attrs.name" :rules="rules">
    <b-form-group v-if="group">
      <b-form-checkbox-group
        v-model="innerValue"
        :state="errors[0] ? false : (valid ? true : null)"
        :aria-describedby="`${$attrs.name}-live-feedback`"
        :switches="$attrs.options ? $attrs.options.switches : false"
      >
        <slot />
      </b-form-checkbox-group>
    </b-form-group>
    <b-form-checkbox
      v-else
      :id="$attrs.name"
      v-model="innerValue"
      :name="$attrs.name"
      :value="$attrs.options ? $attrs.options.checked : true"
      :unchecked-value="$attrs.options ? $attrs.options.unchecked : false"
      :switch="$attrs.options ? $attrs.options.switches : false"
      :state="errors[0] ? false : (valid ? true : null)"
      :aria-describedby="`${$attrs.name}-live-feedback`"
    >
      <slot />
    </b-form-checkbox>
    <b-form-invalid-feedback :id="`${$attrs.name}-live-feedback`">{{ errors[0] }}</b-form-invalid-feedback>
  </ValidationProvider>
</template>


<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
      default: '',
    }, 
    group: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('update-value', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
}
</script>
